import ContainerFluid from 'app/components/Layout/ContainerFluid';
import { LoadingContainer } from 'app/components/LoadingContainer';
import useFetchData from 'app/hooks/useFetchData';
import { createCheckoutPaymentApi } from 'app/services/checkoutApi';
import { getCommonAirportDataApi } from 'app/services/holidayApi';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { selectTranslations } from '../App/slice/selectors';
import HeaderStep from '../HolidayList/HeaderStep';
import BookReservation from './BookReservation';
import ComboInformation from './ComboInformation';
import FlightInformation from './FlightInformation';
import { HolidayCheckoutWrapper } from './styled';
import { ReactComponent as CopyIcon } from 'app/assets/img/copy-icon.svg';
import { windowOpenLink } from 'utils/helper';
import _ from 'lodash';
import { ReactComponent as EmptyImg } from 'app/assets/img/empty.svg';
import PassengerInformation from './PassengerInformation';
import ContactInformation from './ContactInformation';
import { useHolidayOrderDetail } from './hooks/useHolidayOrderDetail';
import { useGlobalFunction } from '../App/hooks/useGlobalFunction';
import { IHolidayOrderDetail } from './types';
import { FareFamilyData, getAllFareFamilies } from 'app/services/fareFamilyApi';
export const HolidayCheckout = () => {
  const { id }: { id: string } = useParams();
  const translations = useSelector(selectTranslations);
  const history = useHistory();
  const [dataInfo, setDataInfo] = useState<IHolidayOrderDetail | null>(null);
  const [dataAirports, setDataAirports] = useState<any>();
  const [fareFamilies, setFareFamilies] = useState<FareFamilyData[]>([]);
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();
  const { onFetchOrderDetail, isLoading: isLoadingDetail } =
    useHolidayOrderDetail({
      shouldValidate: false,
      onSuccess: response => {
        if (response?.orderState?.value === 'cancelled') {
          windowOpenLink({
            url: `/holiday/payment-callback?vnp_TxnRef=${response.orderCode}&result_code=0`,
            target: '_self',
          });
        } else if (response?.orderState?.value === 'success') {
          windowOpenLink({
            url: `/holiday/payment-callback?vnp_TxnRef=${response.orderCode}&result_code=1`,
            target: '_self',
          });
        } else {
          setDataInfo(response);
        }
      },
    });
  const { onFetchData: onFetchAirport } = useFetchData({
    actionApi: getCommonAirportDataApi,
    IIFE: false,
    onSuccess: response => {
      setDataAirports(response.data);
    },
  });
  useEffect(() => {
    onFetchAirport();
    getAllFareFamilies().then(setFareFamilies);
  }, []);
  useEffect(() => {
    if (id) {
      onFetchOrderDetail({ payloadData: { orderCode: id } });
    }
  }, [id]);
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<any>(null);
  const handleCopy = async () => {
    if (!dataInfo?.orderCode) return;
    try {
      await navigator.clipboard.writeText(dataInfo.orderCode || '');
      setCopied(true);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {}
  };
  const onClickPaymentNow = () => {
    const formData = new FormData();
    formData.append('idHash', dataInfo?.idHash ?? '');
    formData.append('queryCallback', '');
    formData.append('type', 'holiday');
    onFetchCreateCheckout({ payloadData: formData });
  };
  const timeOutRef = useRef<any>(null);
  const onTimeout = () => {
    if (!id) return;
    if (timeOutRef.current) {
      clearTimeout(timeOutRef.current);
    }
    timeOutRef.current = setTimeout(() => {
      onFetchOrderDetail({ payloadData: { orderCode: id } });
    }, 80000); // 1 phút 20 giây
  };
  useEffect(() => {
    return () => {
      if (timeOutRef.current) {
        clearTimeout(timeOutRef.current);
      }
    };
  }, []);
  const { onFetchData: onFetchCreateCheckout, isLoading: isLoadingCheckout } =
    useFetchData({
      actionApi: createCheckoutPaymentApi,
      IIFE: false,
      onSuccess: response => {
        if (!dataInfo?.orderCode) return;
        if (response?.paymentSuccess) {
          windowOpenLink({
            url: `/holiday/payment-callback?vnp_TxnRef=${dataInfo.orderCode}&result_code=1`,
            target: '_self',
          });
        } else {
          onOpenDialogNoti({
            type: 'ERROR',
            isShow: true,
            title: translations?.['b2b.txt.payment-deposit-fail'] ?? '',
            content: response?.message ?? '',
            closable: true,
            onCloseDialog: onCloseDialogNoti,
            maskClosable: false,
          });
        }
      },
    });
  const onClickDetail = () => {
    if (!dataInfo?.orderCode) return;
    history.push(`/holiday/order-detail/${dataInfo.orderCode}`);
  };
  return (
    <LoadingContainer loading={isLoadingDetail || isLoadingCheckout}>
      <HeaderStep />
      <ContainerFluid>
        {!_.isEmpty(dataInfo) ? (
          <HolidayCheckoutWrapper>
            {!_.isEmpty(dataInfo) && (
              <BookReservation
                dataInfo={dataInfo}
                onClickPaymentNow={onClickPaymentNow}
                onTimeout={onTimeout}
                onClickDetail={onClickDetail}
              />
            )}
            <BoxPassengerInformation>
              <Title>{translations?.['b2b.txt.productInformation']}</Title>
              <Line />
              {dataInfo && <ComboInformation dataInfo={dataInfo} />}
            </BoxPassengerInformation>
            <BoxPassengerInformation>
              <Title>{translations?.['b2b.txt.orderInfo']}</Title>
              {/* <SubTitle>
                  {translations?.['b2c.txt.order-code']}
                  <span>: {dataInfo.orderCode}</span>{' '}
                  <CopyButton onClick={handleCopy}>
                    {copied ? <TickIcon>✓</TickIcon> : <CopyIconCss />}
                  </CopyButton>
                </SubTitle> */}
              <Line />
              <FlightInformation
                flightInfo={dataInfo?.orderItems?.flights}
                comboInfo={dataInfo?.orderItems?.tickets}
                hotelInfo={dataInfo?.orderItems?.hotels}
                dataAirports={dataAirports}
                fareFamilies={fareFamilies}
                note={dataInfo?.note || ''}
              />
            </BoxPassengerInformation>
            <BoxPassengerInformation>
              <Title>{translations?.['b2b.txt.passengerInformation']}</Title>
              <Line />
              <PassengerInformation dataPassenger={dataInfo.passengers} />
            </BoxPassengerInformation>
            <BoxPassengerInformation>
              <Title>{translations?.['b2c.ref.contactInfo']}</Title>
              <Line />
              <ContactInformation dataContact={dataInfo.contact} />
            </BoxPassengerInformation>
          </HolidayCheckoutWrapper>
        ) : (
          <>
            <EmptyImg style={{ margin: 'auto', marginTop: 30 }} />
          </>
        )}
      </ContainerFluid>
    </LoadingContainer>
  );
};
const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
`;
const SubTitle = styled.div`
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
`;
const Line = styled.div`
  height: 1px;
  background-color: #e5e5e5;
  margin: 12px -11px;
`;
const BoxPassengerInformation = styled.div`
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 20px;
`;
const CopyButton = styled.div`
  border: none;
  padding: 0 12px;
  cursor: pointer;
  // width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  // height: 50px;
`;
const CopyIconCss = styled(CopyIcon)`
  height: 15px;
  filter: brightness(0) saturate(100%) invert(64%) sepia(63%) saturate(1246%)
    hue-rotate(345deg) brightness(99%) contrast(101%);
`;
const TickIcon = styled.div`
  height: 10px;
  width: 20px;
  color: var(--color-9);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
`;
